import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

import { getQuiz, saveUpdateAnswer } from 'store/lesson-actions';

import classes from './RadioQuestion.module.css';

const RadioQuestion = props => {
  const { t } = useTranslation(['lesson']);
  const dispatch = useDispatch();
  const dataAcademy = useSelector(state => state.academyInfo);
  const dataLesson = useSelector(state => state.lessonInfo);
  const [answer, setAnswer] = useState('');

  useEffect(() => {
    props.questionData.choices.map(choice => {
      if (choice.answer) {
        setAnswer(choice.idChoice.toString());
        props.nextQuestion();
      }
    });
  }, []);

  const handleChange = event => {
    setAnswer(event.target.value);
    props.nextQuestion();
    (async () => {
      const answer = await saveUpdateAnswer(
        props.idApplication,
        event.target.value,
        true
      );
      if (
        props.currentQuestion !==
        dataLesson.quizData.questions.length
      ) {
        if (answer) {
          dispatch(
            getQuiz(
              dataLesson.data.idQuiz,
              dataLesson.quizEvaluableData.idApplication,
              dataAcademy.data.shortName
            )
          );
        }
      }
    })();
  };
  return (
    <>
      <p className={classes.question}>{props.questionData.body}</p>
      <p className={classes.text}>{t('select_an_option')}</p>
      <FormControl>
        <RadioGroup value={answer} onChange={handleChange}>
          {props.questionData.choices.map(choice => (
            <FormControlLabel
              key={choice.idChoice}
              value={choice.idChoice}
              control={
                <Radio
                  sx={{
                    color: '#a41034',
                    '&.Mui-checked': {
                      color: '#eeeeee'
                    }
                  }}
                />
              }
              label={choice.body}
              className={classes.answer}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </>
  );
};

RadioQuestion.propTypes = {
  // eslint-disable-next-line react/require-default-props
  questionData: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  idApplication: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  currentQuestion: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  nextQuestion: PropTypes.func
};

export default RadioQuestion;
